import React, { useState, useEffect } from "react";
import * as GridConfig from "./audit-inventory-grid-configuration";
import * as GlobalService from "./../global_services";
import * as auditInventoryServices from "./audit-inventory.services";
import ManageAuditInventoryModal from "./manage-audit-inventory.modal.component";
import { StringWms } from "../../../assets/ts/StringWms";
import { ConcurrencyManager } from "../../../assets/vendor/concurrencyManager/concurrencyManager";
import AuditInventoryReviewAuditJobModal from "./modals/audit-inventory-review-audit-job-modal.component";
import { AddEditColumnModel } from "../../react/components/AddEditColumn/add-edit-columns.component";
import { useFCDebounce } from "../global_services";
import VirtualGridComponent from "../components_proto/VirtualGridComponent/VirtualGridComponent";
import { LoadingModel } from "../components/LoadingModel/LoadingModel";
import { ArrayWms } from "../../../assets/ts/ArrayWms";
import WmsConfirmModel from "../components/WmsConfirmModel/WmsConfirmModel";
import ManageBatchAuditInventoryModal from "./modals/manage-batch-audit-inventory.modal.component";
import AddToExistingBatchModal from "./modals/add-to-existing-batch-modal.component";
import {
    getCsvSummaryExportErrorMessage,
    hasMultipleAuditTypesInMultiSelect,
    hasMultipleCustomersInMultiSelect,
} from "./audit-inventory-csv-summary-utils";
import axios from "axios";

interface Props {
    selector: string;
    windowId: string;
    facId: number;
    facUri: string;
    auditGridData: any;
    userOptions: any;
    locationTypes: any;
    getAuditOptions: any;
    closeJob: any;
    closejobGif: any;
    onRefreshGrid(): void;
    recordsCount: number;
    batchList: any;
    onSummaryClick(): void;
    setSelectedAuditJob(selectedAuditJob: any): void;
    isFilterLoading: boolean;
}

declare var window: any;
const { $ } = window;
let localKendoGrid = null;

const AuditInventoryGrid: React.FC<Props> = (props: Props): any => {
    const defaultColumns = GridConfig.cycleCountJobsGridColumns(
        StringWms.convertSringToOption(window.translate("Audit_Inventory_GrideHeaders"))
    );

    let firstFiftyAxiosSource = null;
    let axiosSource = null;
    let isApiCanceled = false;

    const [schema] = useState(GridConfig.cycleCountJobsGridSchema());
    const [gridData, setGridData] = useState([]);
    const [selectedRow, setSelectedRow] = useState(0);
    const [selectedRowData, setSelectedRowData] = useState([]);
    const [auditCountsEditUris, setAuditCountsEditUris] = useState([]);
    const [auditType, setAuditType] = useState("Create");
    const [auditBatchType, setAuditBatchType] = useState("Create");
    const [isShowManageAuditInventoryModal, setIsShowManageAuditInventoryModal] = useState(false);
    const [isShowManageBatchAuditInventoryModal, setIsShowManageBatchAuditInventoryModal] = useState(false);
    const [isReviewAuditJobModelOpen, setReviewAuditJobModelOpen] = useState(false);
    const [isReviewButtonDisabled, setIsReviewButtonDisabled] = useState(true);
    const [isJobClosed, setIsJobClosed] = useState(false);
    const [auditCountsUris, setAuditCountUris] = useState([]);
    const [isEditButtonEnable, setIsEditButtonEnable] = useState(false);
    const [isJobStatusIsOpen, setIsJobStatusIsOpen] = useState(false);
    const [gridPageSize] = useState(auditInventoryServices.gridPageSize);
    const [isAllDataLoad, setIsAllDataLoad] = useState<boolean>(false);
    const [showLoadingError, setShowLoadingError] = useState<boolean>(false);
    const [filterText, setFilterText] = useState("");
    const [fullFilterText, setFullFilterText] = useState("");
    const [isOpenColumnModal, setIsOpenColumnModal] = useState<boolean>(false);
    const [gridConfig, setGridConfig] = useState("");
    const [isGridConfigLoaded, setIsGridConfigLoaded] = useState<boolean>(false);
    const [isNewColumnAdded, setIsNewColumnAdded] = useState(false);
    const [overlayScreenShow, setOverlayScreenShow] = useState(false);
    const [isGridDataLoading, setIsGridDataLoading] = useState(false);
    const [isFilterRowCountLoading] = useState<boolean>(false);
    const [totalRequest, setTotalRequest] = useState(0);
    const [isConfirmModel, setIsConfirmModel] = useState<boolean>(false);
    const [isOpenAddToExistingBatchModal, setIsOpenAddToExistingBatchModal] = useState<boolean>(false);
    const [isAddToExistingBatchStatusIsIOpen, setIsAddToExistingBatchStatusIsIOpen] = useState<boolean>(false);
    const [isRemoveFromBatchStatusIsIOpen, setIsRemoveFromBatchStatusIsIOpen] = useState<boolean>(false);
    const [isOpenRemoveFromBatchModal, setIsOpenRemoveFromBatchModal] = useState<boolean>(false);
    const [isEditBatchStatusIsIOpen, setIsEditBatchStatusIsIOpen] = useState<boolean>(false);
    const [isEditWarningModelOpen, setIsEditWarningModelOpen] = useState<boolean>(false);
    const [isAllJobClosed, setIsAllJobClosed] = useState(false);
    const [isDeleteConfirmModel, setIsDeleteConfirmModel] = useState<boolean>(false);
    const [hasMultipleCustomers, setHasMultipleCustomers] = useState<boolean>(false);
    const [hasMultipleAuditTypes, setHasMultipleAuditTypes] = useState<boolean>(false);

    const TIMES_CIRCLE_ICON = "fa fa-times-circle";
    const CHECK_SQUARE_ICON = "fa fa-check-square-o";

    const gridId = props.selector + "Grid";
    const gridDomSelector = props.windowId ? "." + props.windowId + " #" + gridId : "#" + gridId;
    useEffect(() => {
        (async () => {
            const isLoaded = await auditInventoryServices.getAuditInventoryClientMetaData();
            setGridConfig(auditInventoryServices.getAuditInventoryGridOptionInMetaData());
            setIsGridConfigLoaded(isLoaded);
        })();
    }, []);

    useEffect(() => {
        if (props.auditGridData.length === gridPageSize || props.auditGridData < gridPageSize) {
            setIsAllDataLoad(false);
        }
        setGridData(props.auditGridData);
        resetSelections();
        setIsGridDataLoading(false);
        auditInventoryServices.getAuditInventoryClientMetaData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.auditGridData]);

    const resetSelections = () => {
        setIsJobClosed(false);
        setSelectedRow(0);
        setSelectedRowData([]);
        setAuditCountsEditUris([]);
        setIsReviewButtonDisabled(true);
        setHasMultipleCustomers(false);
        setHasMultipleAuditTypes(false);
        if (localKendoGrid != null) {
            localKendoGrid.clearSelections(() => {
                localKendoGrid.repaintSelections();
            });
        }
    };

    const updateBatchStatus = (selectedRows) => {
        // Early return if no selection
        if (!selectedRows?.length) {
            setIsEditBatchStatusIsIOpen(false);
            return;
        }

        // Check if any row has invalid status or audit type
        const hasInvalidRow = selectedRows.some((row) => row.Status !== "0" || row.AuditType !== "Item");
        if (hasInvalidRow) {
            setIsEditBatchStatusIsIOpen(false);
            return;
        }

        const firstBatchName = selectedRows.find((row) => row.BatchName)?.BatchName;
        const allSameBatch = firstBatchName && selectedRows.every((row) => row.BatchName === firstBatchName);

        setIsEditBatchStatusIsIOpen(props.batchList.length > 0 && allSameBatch);
    };

    const selectRow = (KendoGrid) => {
        localKendoGrid = KendoGrid;
        let currentSelections = KendoGrid.getNumberOfSelections();
        let tempAuditCountsEditUris: Array<string> = [];
        var tmpIsBatch = false;
        let hasExistingBatch = false;
        if (currentSelections === 1) {
            var tmpIsEditButtonEnable = KendoGrid.valueExists("Status", "0");
            tmpIsBatch = KendoGrid.valueExists("Status", "0") && KendoGrid.valueExists("AuditType", "Item");
            let data = {};
            let tempKey = KendoGrid.getKeys();
            data = KendoGrid.getItem(tempKey);
            setSelectedRowData([data]);
            props.setSelectedAuditJob(data);
            setIsEditButtonEnable(tmpIsEditButtonEnable);
        }
        setSelectedRow(currentSelections);
        if (currentSelections > 0) {
            let tempIsReviewButtonDisabled = false;
            let tempIsJobClosed = false;
            let tempAuditCountsUris: Array<string> = [];
            tmpIsBatch = true;
            let selectedValues = KendoGrid.getValues();
            const tempHasMultipleCustomers = hasMultipleCustomersInMultiSelect(currentSelections, selectedValues);
            const tempHasMultipleAuditTypes = hasMultipleAuditTypesInMultiSelect(currentSelections, selectedValues);

            selectedValues.forEach((gridValue: any) => {
                tempAuditCountsUris.push(gridValue.CountsUri);
                tempAuditCountsEditUris.push(gridValue.EditUri);
                if (parseInt(gridValue.Status) !== 2) {
                    tempIsReviewButtonDisabled = true;
                }
                if (parseInt(gridValue.Status) === 3) {
                    tempIsJobClosed = true;
                }

                if (gridValue.Status !== "0" || gridValue.AuditType !== "Item") {
                    tmpIsBatch = false;
                } else {
                    // Check if any row has a BatchName
                    if (gridValue.BatchName !== null && gridValue.BatchName !== "") {
                        hasExistingBatch = true;
                    }
                }
            });

            setHasMultipleCustomers(tempHasMultipleCustomers);
            setHasMultipleAuditTypes(tempHasMultipleAuditTypes);
            const tempIsAllJobClosed = selectedValues.every((gridValue) => parseInt(gridValue.Status) === 3);
            setIsAllJobClosed(tempIsAllJobClosed);
            updateBatchStatus(KendoGrid.getValues());
            setIsJobClosed(tempIsJobClosed);
            setIsReviewButtonDisabled(tempIsReviewButtonDisabled);
            setAuditCountUris(tempAuditCountsUris);
            setSelectedRowData(KendoGrid.getValues());
        } else {
            setIsAllJobClosed(false);
            setHasMultipleCustomers(false);
            setHasMultipleAuditTypes(false);
        }
        setAuditCountsEditUris(tempAuditCountsEditUris);
        setIsJobStatusIsOpen(tmpIsBatch && !hasExistingBatch);
        setIsAddToExistingBatchStatusIsIOpen(props.batchList.length > 0 && tmpIsBatch && !hasExistingBatch);
        setIsRemoveFromBatchStatusIsIOpen(props.batchList.length > 0 && tmpIsBatch && hasExistingBatch);
    };

    const openReviewAuditJobModel = () => {
        setReviewAuditJobModelOpen(true);
    };
    const onCreateAuditInventoryClick = () => {
        setAuditType("Create");
        setIsShowManageAuditInventoryModal(true);
    };
    const onEditAuditInventoryClick = async () => {
        if (!selectedRowData || !selectedRowData[0].EditUri) {
            console.error("No audit selected or EditUri missing");
            return;
        }
        auditInventoryServices
            .getAuditDetails(selectedRowData[0].EditUri)
            .then((auditDetails) => {
                if (auditDetails && auditDetails?.Status === 0) {
                    setAuditType("Edit");
                    setIsShowManageAuditInventoryModal(true);
                } else {
                    setIsEditWarningModelOpen(true);
                    refreshAuditInventoryGrid();
                }
            })
            .finally(() => {});
    };
    const onAddBatchAuditInventoryClick = () => {
        setAuditBatchType("Create");
        setIsShowManageBatchAuditInventoryModal(true);
    };
    const onEditBatchAuditInventoryClick = () => {
        setAuditBatchType("Edit");
        setIsShowManageBatchAuditInventoryModal(true);
    };
    const onAddToBatchClick = () => {
        setIsOpenAddToExistingBatchModal(true);
    };
    const onCloseAddToExistingBatchModal = (isRefreshGrid = false) => {
        setIsOpenAddToExistingBatchModal(false);
        if (isRefreshGrid === true) {
            refreshAuditInventoryGrid();
        }
    };

    const onCloseAuditJobClick = () => {
        if (auditCountsEditUris) {
            props.closeJob(auditCountsEditUris);
            setIsConfirmModel(false);
        }
    };

    const openConfirmModel = () => {
        setIsConfirmModel(true);
    };

    const closeConfirmModel = () => {
        setIsConfirmModel(false);
    };

    const onDeleteAuditJobClick = () => {
        auditInventoryServices.deteleAudit(auditCountsEditUris).then((response) => {
            GlobalService.notification("success", window.translate("Label_Audit_Delete"));
            closeDeleteConfirmModel();
            refreshAuditInventoryGrid();
        });
    };

    const openDeleteConfirmModel = () => {
        setIsDeleteConfirmModel(true);
    };

    const closeDeleteConfirmModel = () => {
        setIsDeleteConfirmModel(false);
    };

    const closeRemoveFromBatchModal = (isRefreshGrid = false) => {
        setIsOpenRemoveFromBatchModal(false);
        if (isRefreshGrid === true) {
            refreshAuditInventoryGrid();
        }
    };
    const onRemoveFromBatchClick = () => {
        // Get unique batch names from selected rows
        const uniqueBatchNames = Array.from(new Set(selectedRowData.map((row) => row.BatchName)));

        const editBatchDataArray = uniqueBatchNames
            .map((batchName) => {
                const auditIdsToRemove = selectedRowData
                    .filter((row) => row.BatchName === batchName)
                    .map((row) => parseInt(row.EditUri?.split("/").pop()));

                const batch = props.batchList.find((b) => b.Name === batchName);

                if (batch) {
                    const updatedBatch = {
                        ...batch,
                        InventoryAuditIds: batch.InventoryAuditIds.filter((id) => !auditIdsToRemove.includes(id)),
                    };

                    return {
                        batch: updatedBatch,
                        editUri: batch._links[0].Href,
                    };
                }
                return null;
            })
            .filter(Boolean); // Remove any null entries

        editBatchDataArray.forEach((editBatchData) => {
            auditInventoryServices
                .editBatch(editBatchData)
                .then(() => {
                    GlobalService.notification("success", window.translate("Label_Batch_Removed_Successfully"));

                    closeRemoveFromBatchModal(true);
                })
                .catch((error) => {
                    console.log("error", error);
                    GlobalService.notification("error", error.data.Message);
                });
        });
    };

    const openRemoveFromBatchModal = () => {
        setIsOpenRemoveFromBatchModal(true);
    };
    const onCloseManageAuditInventoryModal = () => {
        setIsShowManageAuditInventoryModal(false);
    };
    const onCloseManageBatchAuditInventoryModal = (isRefreshGrid = false) => {
        setIsShowManageBatchAuditInventoryModal(false);
        if (isRefreshGrid === true) {
            refreshAuditInventoryGrid();
        }
    };
    const clearSelectionOfGrid = () => {
        if (localKendoGrid != null) {
            localKendoGrid.clearSelections(() => {
                localKendoGrid.repaintSelections();
            });
        }
    };

    const refreshAuditInventoryGrid = useFCDebounce(() => {
        clearSelectionOfGrid();
        if (props.facUri) {
            setIsGridDataLoading(true);
            props.onRefreshGrid();
        }
    }, 700);

    const onGridDataBound = (_: any, kendoGrid: any) => {
        localKendoGrid = kendoGrid;
    };

    const cancelLoadAllData = () => {
        if (firstFiftyAxiosSource) {
            firstFiftyAxiosSource.cancel();
            firstFiftyAxiosSource = null;
        }
        if (axiosSource) {
            axiosSource.cancel();
            axiosSource = null;
        }
        isApiCanceled = true;
        setIsGridDataLoading(false);
        setOverlayScreenShow(false);
        setGridData([]);
        setIsAllDataLoad(false);
    };

    const clickEventOfContextMenu = (obj: any, e: any) => {
        if (obj.onClickFunc) {
            obj.onClickFunc();
        }
    };

    const saveMetaData = () => {
        var grid = $(gridDomSelector).data("kendoGrid");
        var sort = grid.dataSource.sort() ? grid.dataSource.sort() : [];
        let finalSubmission = localKendoGrid.prepareGridOptionsForStorage(grid.columns, sort, grid.dataSource.filter());
        auditInventoryServices.setAuditInventoryGridOptionInMetaData(finalSubmission);
    };

    const resetGridAllMessage = () => {
        if (isAllDataLoad) {
            setIsNewColumnAdded(true);
        }
    };
    const callForGetNewData = () => {
        if (props.recordsCount > 0 && props.recordsCount <= gridPageSize) {
            loadAllRecords(false);
        } else {
            resetGridAllMessage();
        }
    };

    const getAllResponseData = (data: any) => {
        if (!isApiCanceled) {
            let allData = [];
            data.forEach((obj: any) => {
                allData = [...obj, ...allData];
            });
            setGridData(allData);
            setOverlayScreenShow(false);
            setIsGridDataLoading(false);
            setIsAllDataLoad(true);
            setIsNewColumnAdded(false);
        } else {
            setIsGridDataLoading(false);
        }
    };

    const sequence = (n) => {
        let seq = [];
        for (let i = 0; i < n; i++) {
            seq.push(i);
        }
        return seq;
    };

    const loadAllRecords = (isLoaderPopupShow) => {
        isApiCanceled = false;
        if (isLoaderPopupShow) {
            setIsGridDataLoading(true);
            setGridData([]);
        }

        axiosSource = axios.CancelToken.source();
        let api = axios.create({
            baseURL: "/WebUI/Inventory/ManageAudits",
            headers: { "Access-Control-Allow-Origin": "*" },
            cancelToken: axiosSource.token,
        });
        const MAX_CONCURRENT_REQUESTS = 3;
        let totalRequest = Math.ceil(props.recordsCount / gridPageSize);
        setTotalRequest(totalRequest);
        var manager = ConcurrencyManager(api, MAX_CONCURRENT_REQUESTS, GlobalService);

        Promise.all(
            sequence(totalRequest).map((i) =>
                api.get(`/AuditOptions?facilityUri=${props.facUri}&pgnum=` + (i + 1) + "&pgsiz=" + gridPageSize)
            )
        )
            .then((responses) => {
                let auditInventoryData = responses.map((r) => r.data.Audits);
                getAllResponseData(auditInventoryData);
            })
            .catch((error) => {
                console.error("Promise.all catch", error);
                setShowLoadingError(true);
                cancelLoadAllData();
            })
            .then(() => {
                if (manager) {
                    manager.detach();
                }
            });
    };

    const onClickLoadAllRecords = () => {
        setOverlayScreenShow(true);

        if (firstFiftyAxiosSource) {
            firstFiftyAxiosSource.cancel();
            firstFiftyAxiosSource = null;
        }
        firstFiftyAxiosSource = axios.CancelToken.source();
        axios
            .get(`/WebUI/Inventory/ManageAudits/AuditOptions?facilityUri=${props.facUri}&pgnum=1&pgsiz=40`, {
                cancelToken: firstFiftyAxiosSource.token,
            })
            .then((response) => {
                firstFiftyAxiosSource = "";
                setGridData(response.data.Data);
                loadAllRecords(false);
            });
    };

    const onClickResetGrid = () => {
        const finalSubmission = {
            optionsData: {},
        };
        auditInventoryServices.setAuditInventoryGridOptionInMetaData(finalSubmission);
    };

    const eventClickExportGrid = () => {
        $(gridDomSelector).getKendoGrid().saveAsExcel();
    };

    const onGridFilterApplied = () => {
        var grid = $(gridDomSelector).data("kendoGrid");
        var dataSource = grid.dataSource;
        setTimeout(() => {
            let filter = dataSource.filter();
            var sortArray = grid.dataSource.sort() ? grid.dataSource.sort() : [];
            var finalSubmission = localKendoGrid.prepareGridOptionsForStorage(grid.columns, sortArray, filter);
            auditInventoryServices.setAuditInventoryGridOptionInMetaData(finalSubmission);
            setFilterAppliedText(filter);
        }, 50);
    };

    const setFilterAppliedText = (filterObj) => {
        if (!filterObj) {
            setFilterText("");
            setFullFilterText("");
            return;
        }
        var filterConditionTitle = {
            lte: "Is Less Than Or Equal To",
            eq: "Is Equal To",
            lt: "Is Less Than",
            neq: "Is Not Equal To",
            gte: "Is Greater Than Or Equal To",
            gt: "Is Greater Than",
            startswith: "Starts With",
            endswith: "Ends With",
            contains: "Contains",
            doesnotcontain: "Does Not Contain",
            isnull: "Is Null",
            isnotnull: "Is Not Null",
            isempty: "Is Empty",
            isnotempty: "Is Not Empty",
            isnullorempty: "Has No Value",
            isnotnullorempty: "Has Value",
        };

        var filterText = "";
        var fullFilterText = "";
        var filterList = filterObj.filters;

        filterList.map((item) => {
            var title = defaultColumns.find((x) => x.field === item.field).title;
            filterText += title + " : " + item.value + ",";
            fullFilterText += title + " " + filterConditionTitle[item.operator] + " : " + item.value + "<br>";
            return item;
        });
        filterText = filterText.slice(0, -1);
        setFilterText(filterText);
        setFullFilterText(fullFilterText);
    };

    const onColumnReorder = (event: any) => {
        var grid = $(gridDomSelector).data("kendoGrid");
        var sortArray = grid.dataSource.sort() ? grid.dataSource.sort() : [];
        let gridColumn = grid.getOptions().columns;
        let switchedArray = ArrayWms.switchIndexByField(gridColumn, event.newIndex, event.oldIndex);
        let finalSubmission = localKendoGrid.prepareGridOptionsForStorage(
            switchedArray,
            sortArray,
            grid.dataSource.filter()
        );
        auditInventoryServices.setAuditInventoryGridOptionInMetaData(finalSubmission);
    };

    const onColumnResize = () => {
        var grid = $(gridDomSelector).data("kendoGrid");
        var sortArray = grid.dataSource.sort() ? grid.dataSource.sort() : [];
        let finalSubmission = localKendoGrid.prepareGridOptionsForStorage(
            grid.columns,
            sortArray,
            grid.dataSource.filter()
        );
        auditInventoryServices.setAuditInventoryGridOptionInMetaData(finalSubmission);
    };

    const onClickClearSorts = () => {
        var grid = $(gridDomSelector).data("kendoGrid");
        var finalSubmission = localKendoGrid.prepareGridOptionsForStorage(grid.columns, [], grid.dataSource.filter());
        auditInventoryServices.setAuditInventoryGridOptionInMetaData(finalSubmission);
    };

    const onSort = (event: any) => {
        var grid = $(gridDomSelector).data("kendoGrid");
        var sortArray = grid.dataSource.sort() ? grid.dataSource.sort() : [];
        GlobalService.sortDataset(sortArray, event.sort);
        var gridColumn = grid.getOptions().columns;
        var finalSubmission = localKendoGrid.prepareGridOptionsForStorage(
            gridColumn,
            sortArray,
            grid.dataSource.filter()
        );
        auditInventoryServices.setAuditInventoryGridOptionInMetaData(finalSubmission);
    };

    const onToggleColumnModal = (isOpen: boolean) => () => {
        setIsOpenColumnModal(isOpen);
    };

    const openSummary = () => {
        if (selectedRowData.length < 1) {
            return;
        }

        const auditUris = selectedRowData.map((job: any) => job.EditUri).filter((uri: string) => uri);
        if (auditUris.length === 0) {
            return;
        }

        if (hasMultipleCustomersInMultiSelect(selectedRowData.length, selectedRowData)) {
            return;
        }
        if (hasMultipleAuditTypesInMultiSelect(selectedRowData.length, selectedRowData)) {
            return;
        }

        auditInventoryServices
            .exportMultiJobCSVSummary(auditUris)
            .then(() => {})
            .catch((error: any) => {
                console.error("Error exporting CSV summary:", error);
                const message = getCsvSummaryExportErrorMessage(error, window.translate);
                GlobalService.notification("error", message);
            });
    };

    const closeEditWarningModel = () => {
        setIsEditWarningModelOpen(false);
    };

    let csvSummaryMenuDisabledText = "";
    if (hasMultipleCustomers) {
        csvSummaryMenuDisabledText = window.translate("Label_Cannot_Create_CSV_Summary_Multiple_Customers");
    } else if (hasMultipleAuditTypes) {
        csvSummaryMenuDisabledText = window.translate("Label_Cannot_Create_CSV_Summary_Multiple_Audit_Types");
    } else {
        csvSummaryMenuDisabledText = window.translate(selectedRow === 0 ? "Label_NoRows_Close_Audits" : "");
    }

    return (
        <div className={`audit-inventory-grid`}>
            <div className={"wms-audit-inventory-grid-holder"}>
                {isGridConfigLoaded && (
                    <VirtualGridComponent
                        virtualGridDataLimit={gridPageSize}
                        isNewColumnAdded={isNewColumnAdded}
                        callForGetNewData={callForGetNewData}
                        isAllDataLoad={isAllDataLoad}
                        loadAllRecords={onClickLoadAllRecords}
                        loading={isFilterRowCountLoading || isGridDataLoading || props.isFilterLoading}
                        loadAllMessageFirst={window.translate("Label_Grid_Filter_Message")}
                        loadAllMessageSecond={window.translate("Label_Grid_Filter_Message_2")}
                        showLoadingError={showLoadingError}
                        shawCheckbox={false}
                        id={gridId}
                        showSortColumns={true}
                        showGridSummary={true}
                        showGridResult={true}
                        virtual={true}
                        staticGridData={gridData}
                        totalResult={props.recordsCount}
                        gridName={gridId}
                        windowId={props.windowId}
                        wmsSelector={props.selector + gridId}
                        gridKeySelection={"RowNumber"}
                        exportable={true}
                        isExportSelectedData={true}
                        exportExcelObj={{
                            fileName:
                                "AuditInventoryExport-" +
                                kendo.toString(kendo.parseDate(new Date().toString()), "yyyyMMddhhmmss") +
                                ".xlsx",
                            allPages: true,
                            filterable: true,
                        }}
                        csvExportFileName={"AuditInventoryExport"}
                        eventClickExportGrid={eventClickExportGrid}
                        allColumns={defaultColumns}
                        defaultColumns={defaultColumns}
                        schema={schema}
                        onSelection={selectRow}
                        clickEventOfContextMenu={clickEventOfContextMenu}
                        metaGridConfig={gridConfig}
                        metaDataFieldsName={"AuditInventory"}
                        onGridFilterApplied={onGridFilterApplied}
                        filterText={filterText}
                        fullFilterText={fullFilterText}
                        onDataBound={onGridDataBound}
                        onSort={onSort}
                        onColumnReorder={onColumnReorder}
                        onColumnResize={onColumnResize}
                        onClickClearSorts={onClickClearSorts}
                        onClickResetGrid={onClickResetGrid}
                        eventClickColumns={onToggleColumnModal(true)}
                        isAlignIndexesByProperty={true}
                        emptyRecoredText={window.translate("Window_Title_Label_Empty_Records")}
                        menu={[
                            {
                                name: window.translate("Label_Create"),
                                value: [],
                                disabled: props.facId === 0,
                                icon: "fa fa-plus",
                                color: "green",
                                clickFunc: onCreateAuditInventoryClick,
                                wmsSelector: props.selector + "CreateJob",
                                isContextMenu: false,
                            },
                            {
                                name: window.translate("Label_Manage_Batch"),
                                value: [
                                    {
                                        "name": window.translate("Label_Create_Batch"),
                                        "value": [],
                                        "disabled": selectedRow < 1 || !isJobStatusIsOpen,
                                        "icon": "fa fa-pencil",
                                        "color": "green",
                                        "onClickFunc": onAddBatchAuditInventoryClick,
                                        "wmsSelector": props.selector + "CreateBtach",
                                        "wmsid": "createBatch",
                                        "isContextMenu": true,
                                    },
                                    {
                                        "name": window.translate("Label_Add_To_Batch"),
                                        "value": [],
                                        "disabled": selectedRow < 1 || !isAddToExistingBatchStatusIsIOpen,
                                        "icon": "fa fa-tasks",
                                        "color": "green",
                                        "onClickFunc": onAddToBatchClick,
                                        "wmsSelector": props.selector + "AddToBatch",
                                        "wmsid": "addToBatch",
                                        "isContextMenu": true,
                                    },
                                    {
                                        name: window.translate("Label_Edit_Existing_Batch"),
                                        value: [],
                                        disabled: selectedRow < 1 || !isEditBatchStatusIsIOpen,
                                        // "disabled": false,
                                        "icon": "fa fa fa-pencil",
                                        "color": "green",
                                        "onClickFunc": onEditBatchAuditInventoryClick,
                                        "wmsSelector": props.selector + "EditBatch",
                                        "wmsid": "editBatch",
                                        "isContextMenu": true,
                                    },
                                    {
                                        "name": window.translate("Label_Remove_From_batch"),
                                        "value": [],
                                        "disabled": selectedRow < 1 || !isRemoveFromBatchStatusIsIOpen,
                                        "icon": { TIMES_CIRCLE_ICON },
                                        "color": "green",
                                        "onClickFunc": openRemoveFromBatchModal,
                                        "wmsSelector": props.selector + "RemoveFromBatch",
                                        "wmsid": "removeFromBatch",
                                        "isContextMenu": true,
                                        "loading": props.closejobGif,
                                        "disabledText": window.translate(
                                            selectedRow === 0
                                                ? "Label_NoRows_Close_Audits"
                                                : "Label_Disable_Close_Audits"
                                        ),
                                    },
                                ],
                                disabled: props.facId === 0,
                                icon: "fa fa-layer-group",
                                color: "green",
                                clickFunc: onCreateAuditInventoryClick,
                                wmsSelector: props.selector + "CreateJob",
                                isContextMenu: true,
                                isButtonMenu: true,
                            },
                            {
                                name: window.translate("Label_Manage"),
                                value: [
                                    {
                                        "name": window.translate("Label_Edit"),
                                        "value": [],
                                        "disabled": selectedRow !== 1 || !isEditButtonEnable,
                                        "icon": "fa fa-pencil",
                                        "color": "green",
                                        "onClickFunc": onEditAuditInventoryClick,
                                        "wmsSelector": props.selector + "EditJob",
                                        "wmsid": "editJob",
                                        "isContextMenu": true,
                                    },
                                    {
                                        "name": window.translate("Label_Review"),
                                        "value": [],
                                        "disabled": selectedRow !== 1 || isReviewButtonDisabled,
                                        "icon": "fa fa-tasks",
                                        "color": "green",
                                        "onClickFunc": openReviewAuditJobModel,
                                        "wmsSelector": props.selector + "ReviewJob",
                                        "wmsid": "reviewJob",
                                        "isContextMenu": true,
                                    },
                                    {
                                        "name": window.translate("Label_Close"),
                                        "value": [],
                                        "disabled": selectedRow === 0 || isJobClosed,
                                        "icon": { TIMES_CIRCLE_ICON },
                                        "color": "green",
                                        "onClickFunc": openConfirmModel,
                                        "wmsSelector": props.selector + "CloseJob",
                                        "wmsid": "closeJob",
                                        "isContextMenu": true,
                                        "loading": props.closejobGif,
                                        "disabledText": window.translate(
                                            selectedRow === 0
                                                ? "Label_NoRows_Close_Audits"
                                                : "Label_Disable_Close_Audits"
                                        ),
                                    },
                                    {
                                        "name": window.translate("Label_CSV_Summary"),
                                        "value": [],
                                        "disabled": selectedRow < 1 || hasMultipleCustomers || hasMultipleAuditTypes,
                                        "icon": { TIMES_CIRCLE_ICON },
                                        "color": "green",
                                        "onClickFunc": openSummary,
                                        "wmsSelector": props.selector + "CSVSummary",
                                        "wmsid": "csvSummary",
                                        "isContextMenu": true,
                                        "loading": props.closejobGif,
                                        "disabledText": csvSummaryMenuDisabledText,
                                    },
                                    {
                                        "name": window.translate("Label_Delete"),
                                        "value": [],
                                        "disabled": !isAllJobClosed,
                                        "icon": "fa fa-trash-circle",
                                        "color": "green",
                                        "onClickFunc": openDeleteConfirmModel,
                                        "wmsSelector": props.selector + "Delete",
                                        "wmsid": "deleteJob",
                                        "isContextMenu": true,
                                        "loading": props.closejobGif,
                                        "disabledText": window.translate(
                                            selectedRow === 0
                                                ? "Label_NoRows_Close_Audits"
                                                : "Audit_Inventory_Delete_Disabled_Job_Not_Closed_Or_Counted"
                                        ),
                                    },
                                ],
                                disabled: props.facId === 0,
                                icon: "fa-wrench",
                                color: "green",
                                clickFunc: onCreateAuditInventoryClick,
                                wmsSelector: props.selector + "CreateJob",
                                isContextMenu: true,
                                isButtonMenu: true,
                            },
                            {
                                name: "",
                                wmsSelector: props.selector + "RefreshGrid",
                                value: [],
                                clickFunc: refreshAuditInventoryGrid,
                                disabled: false,
                                icon: "fa-sync-alt",
                                color: "blue",
                                isContextMenu: false,
                                isButtonMenu: true,
                                parentClassName: "auditInventoryRefreshButton",
                            },
                        ]}
                    />
                )}
                {isOpenColumnModal && (
                    <AddEditColumnModel
                        id={"addEditColumnEventNotification"}
                        height={700}
                        windowId={props.windowId}
                        onCloseColumnModel={onToggleColumnModal(false)}
                        isOpenColumnModel={isOpenColumnModal}
                        allSortColumnList={defaultColumns}
                        gridId={gridId}
                        updateGridData={() => {}}
                        saveChangesInMetaData={saveMetaData}
                    />
                )}
                {overlayScreenShow && (
                    <LoadingModel
                        sharedOpenLoadingmodel={overlayScreenShow}
                        onCancelLoadAllData={cancelLoadAllData}
                        sharedTotalRequest={totalRequest}
                    />
                )}
                {isShowManageAuditInventoryModal && (
                    <ManageAuditInventoryModal
                        facId={props.facId}
                        facUri={props.facUri}
                        isOpenManageAuditInventoryModal={isShowManageAuditInventoryModal}
                        onCloseManageAuditInventoryModal={onCloseManageAuditInventoryModal}
                        wmsSelector={props.selector}
                        windowId={props.windowId}
                        userOptions={props.userOptions}
                        locationTypes={props.locationTypes}
                        getAuditOptions={props.getAuditOptions}
                        selectedRowData={selectedRowData[0]}
                        auditType={auditType}
                    />
                )}
                {isShowManageBatchAuditInventoryModal && (
                    <ManageBatchAuditInventoryModal
                        isOpenManageAuditInventoryModal={isShowManageBatchAuditInventoryModal}
                        onCloseManageBatchAuditInventoryModal={onCloseManageBatchAuditInventoryModal}
                        wmsSelector={props.selector}
                        windowId={props.windowId}
                        selectedRowData={selectedRowData}
                        auditBatchType={auditBatchType}
                        userOptions={props.userOptions}
                        facId={props.facId}
                        batchList={props.batchList}
                    />
                )}
                {isOpenAddToExistingBatchModal && (
                    <AddToExistingBatchModal
                        isOpen={isOpenAddToExistingBatchModal}
                        onCloseFunc={onCloseAddToExistingBatchModal}
                        wmsSelector={props.selector}
                        windowId={props.windowId}
                        selectedRowData={selectedRowData}
                        facId={props.facId}
                        batchList={props.batchList}
                    />
                )}
                {isReviewAuditJobModelOpen && (
                    <AuditInventoryReviewAuditJobModal
                        windowId={props.windowId}
                        wmsSelector={props.selector}
                        auditCountsUris={auditCountsUris}
                        auditCountsEditUris={auditCountsEditUris}
                        facilityUri={props.facUri}
                        selectedRowData={selectedRowData}
                        isOpen={isReviewAuditJobModelOpen}
                        refreshGrid={props.onRefreshGrid}
                        onReviewAuditJobModalClose={() => {
                            setReviewAuditJobModelOpen(false);
                        }}
                        getAuditOptions={props.getAuditOptions}
                    />
                )}
            </div>
            <WmsConfirmModel
                id="auditJobDeleteConfirmModel"
                type={window.translate("Audit_Inventory_Confrim_Job_Delete")}
                isOpen={isDeleteConfirmModel}
                height={250}
                width={350}
                thirdBtnLabel={window.translate("Audit_Inventory_Close_Job_Model_Cancle_Btn_Label")}
                thirdBtnSelector={props.selector + "CancelJobBtn"}
                thirdButtonType="yellow"
                thirdBtnIcon="fa-times-circle"
                firstBtnLabel={window.translate("Audit_Inventory_Delete_Job_Model_Delete_Btn_Label")}
                firstBtnSelector={props.selector + "CloseBtn"}
                firstBtnIcon={CHECK_SQUARE_ICON}
                firstButtonType="primary"
                firstBtnOnClickFunc={onDeleteAuditJobClick}
                onCloseFunc={closeDeleteConfirmModel}
                sawCheckBox={false}
                isCallToFront={false}
            >
                <div className="modal-text">
                    <p>{window.translate("Audit_Inventory_Delete_Job_Model_Text")}</p>
                    <p className="modal-worning-text">
                        <strong className="text-orange">
                            <i className="fa fa-exclamation-triangle wms-icon text-orange worning-icon"></i>
                            {window.translate("Audit_Inventory_Warning_Text")}
                        </strong>
                        {window.translate("Audit_Inventory_Delete_Job_Model_Warning")}
                    </p>
                </div>
            </WmsConfirmModel>
            <WmsConfirmModel
                id="auditJobCloseConfirmModel"
                type={window.translate("Audit_Inventory_Close_Job_Model_Title")}
                isOpen={isConfirmModel}
                width={350}
                height={250}
                thirdBtnLabel={window.translate("Audit_Inventory_Close_Job_Model_Cancle_Btn_Label")}
                thirdBtnSelector={props.selector + "CancelJobBtn"}
                thirdButtonType="yellow"
                thirdBtnIcon="fa-times-circle"
                firstBtnLabel={window.translate("Audit_Inventory_Close_Job_Model_Close_Btn_Label")}
                firstBtnSelector={props.selector + "CloseBtn"}
                firstBtnIcon={CHECK_SQUARE_ICON}
                firstButtonType="red"
                firstBtnOnClickFunc={onCloseAuditJobClick}
                conFormModelText={window.translate("Audit_Inventory_Close_Job_Model_Text")}
                onCloseFunc={closeConfirmModel}
                sawCheckBox={false}
                isCallToFront={false}
            />
            <WmsConfirmModel
                id="auditJobEditWarningModel"
                type={window.translate("Audit_Inventory_Edit_Warning_Model_Title")}
                isOpen={isEditWarningModelOpen}
                onCloseFunc={closeEditWarningModel}
                conFormModelText={window.translate("Audit_Inventory_Edit_Warning_Model_Text")}
                thirdBtnLabel={""}
                firstBtnIcon={CHECK_SQUARE_ICON}
                firstBtnLabel={window.translate("Label_Ok")}
                firstBtnSelector="auditJobEditWarningOkBtn"
                firstButtonType="yellow"
                firstBtnOnClickFunc={closeEditWarningModel}
                isFirstBtnSaw={true}
                isSecondBtnSaw={false}
                isThirdBtnSaw={false}
                sawCheckBox={false}
            />
            <WmsConfirmModel
                id="removeFromBatchModal"
                type={window.translate("Label_AreYouSure_Title")}
                isOpen={isOpenRemoveFromBatchModal}
                width={350}
                height={250}
                thirdBtnLabel={window.translate("Label_Cancel")}
                thirdBtnSelector={props.selector + "CancelBatchBtn"}
                thirdButtonType="yellow"
                thirdBtnIcon="fa-times-circle"
                firstBtnLabel={window.translate("Label_Continue")}
                firstBtnSelector={props.selector + "RemoveFromBatchBtn"}
                firstBtnIcon={CHECK_SQUARE_ICON}
                firstButtonType="blue"
                firstBtnOnClickFunc={onRemoveFromBatchClick}
                conFormModelText={window.translate("Label_Remove_From_Batch_Description")}
                onCloseFunc={closeRemoveFromBatchModal}
                sawCheckBox={false}
                isCallToFront={false}
            />
        </div>
    );
};
AuditInventoryGrid.propTypes = {};

export default React.memo(AuditInventoryGrid);
